export default {
    name: "",
    props: {
        target: Object,
        container: Object,
        dragArea: Boolean,
        origin: Boolean,
        transformOrigin: Array,
        edge: Boolean,
        ables: Array,
        className: String,
        pinchThreshold: Number,
    },
};
